import { module } from 'angular';
import { publicRoutesConfig } from './public-routing';
import { PublicComponent } from './public.component';
import { GmcFooterComponent, PublicAdditionalModalComponent, PublicHeaderComponent } from './components';
import { AuthModule } from '../auth/auth.module';

export const PublicModule = module('app.states.public', [
  AuthModule.name
])
  .component('public', PublicComponent)
  .component('publicHeader', PublicHeaderComponent)
  .component('gmcFooter', GmcFooterComponent)
  .component('publicAdditionalModal', PublicAdditionalModalComponent)
  .config(publicRoutesConfig);



// WEBPACK FOOTER //
// ./app/states/public/public.module.ts